/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{neverReached as e}from"../../../../../../core/compilerUtils.js";import{NormalType as r}from"../attributes/NormalAttribute.glsl.js";import{VertexNormal as o}from"../attributes/VertexNormal.glsl.js";import{VertexPosition as a}from"../attributes/VertexPosition.glsl.js";import{NormalsDoubleSidedMode as d}from"./Normals.glsl.js";import{glsl as i}from"../../shaderModules/interfaces.js";function l(l,n){const s=l.fragment;switch(n.doubleSidedMode){case d.None:s.code.add(i`vec3 _adjustDoublesided(vec3 normal) {
return normal;
}`);break;case d.View:l.include(a,n),s.code.add(i`vec3 _adjustDoublesided(vec3 normal) {
return dot(normal, vPositionWorldCameraRelative) > 0.0 ? -normal : normal;
}`);break;case d.WindingOrder:s.code.add(i`vec3 _adjustDoublesided(vec3 normal) {
return gl_FrontFacing ? normal : -normal;
}`);break;default:e(n.doubleSidedMode);case d.COUNT:}switch(n.normalType){case r.Attribute:case r.Compressed:l.include(o,n),s.code.add(i`vec3 shadingNormalWorld() {
return _adjustDoublesided(normalize(vNormalWorld));
}
vec3 shadingNormal_view() {
vec3 normal = normalize(vNormalView);
return gl_FrontFacing ? normal : -normal;
}`);break;case r.ScreenDerivative:l.include(a,n),s.code.add(i`vec3 shadingNormalWorld() {
return normalize(cross(
dFdx(vPositionWorldCameraRelative),
dFdy(vPositionWorldCameraRelative)
));
}
vec3 shadingNormal_view() {
return normalize(cross(dFdx(vPosition_view),dFdy(vPosition_view)));
}`);break;case r.Ground:n.spherical?(l.include(a,n),s.code.add(i`vec3 shadingNormalWorld() {
return normalize(positionWorld());
}`)):s.code.add(i`vec3 shadingNormalWorld() {
return vec3(0.0, 0.0, 1.0);
}`),s.code.add(i`vec3 shadingNormal_view() {
return normalize(cross(dFdx(vPosition_view),dFdy(vPosition_view))).xyz;
}`);break;default:e(n.normalType);case r.COUNT:}}export{l as ComputeShadingNormal};
